import React, { createContext, useContext } from "react";
import { ChatReply } from "../graphql/types/graphql";

export interface EventReporter {
  onLogin: (name: string, userRole: string) => void;
  onLogout: () => void;
  setUserRole: (role: string) => void;
  reportEvent: (eventId: string, props?) => void;
  reportServerEvent: (props?) => void;
  consent: () => void;
  reportAnswer: (answer: ChatReply) => void;
}

const reporterContext = createContext<EventReporter>(null);
export const useEventReportedContext = () => useContext(reporterContext);
export const EventReporterContextProvider = ({
  children,
  eventReporter,
}: {
  children: any;
  eventReporter: EventReporter;
}) => {
  return (
    <reporterContext.Provider value={eventReporter}>
      {children}
    </reporterContext.Provider>
  );
};
